import { CommonBG, Rule } from '@riddler-co-jp/specc-ui-components';
import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import {
  InstructionColor,
  InstructionLogo,
  InstructionText,
} from '../../../../lib/instructionSettings';
import { deleteData, hasData } from '../../../localStorage/LocalStorageManager';
import Dialog from '../../../uiElements/Dialog';

interface RuleInstrctionProps {
  //stageId: number;
  ruleImgSrc?: string;
  onStart?: () => void;
  onBack?: () => void;
}

const Energy1Rule: React.FC<RuleInstrctionProps> = () => {
  const navigate = useNavigate();
  const { trainingId } = useParams<'trainingId'>();

  const text = InstructionText[1];
  const [isShowModal, setIsShowModal] = React.useState<boolean>(false);

  return (
    <CommonBG>
      <Rule
        title={text.title}
        mission={text.mission}
        description={text.description}
        video={text.video}
        onStart={() => {
          if (!trainingId) {
            return;
          }
          if (hasData('energy1', trainingId)) {
            setIsShowModal(true);
          } else {
            navigate(`/${trainingId}/energy1/countdown`);
          }
        }}
        onBack={() => navigate(`/${trainingId}/stages`)}
        color={InstructionColor}
        logo={InstructionLogo}
      />
      <Dialog
        message={
          '前回の進捗があります。続きから始めますか？\n新規に始める場合は「新規に始める」を選択してください。'
        }
        isShow={isShowModal}
        cancelText={'新規に始める'}
        onCancel={() => {
          if (!trainingId) {
            return;
          }
          deleteData('energy1', trainingId);
          navigate(`/${trainingId}/energy1/countdown`);
        }}
        onConfirm={() => {
          const currentPage =
            localStorage.getItem('currentpage-energy1') ?? 'countdown';
          navigate(`/${trainingId}/energy1/${currentPage}`);
        }}
      />
    </CommonBG>
  );
};

export default Energy1Rule;
